import { render } from "./SystemTutorial.vue?vue&type=template&id=3574d08e&ts=true"
import script from "./SystemTutorial.vue?vue&type=script&lang=ts"
export * from "./SystemTutorial.vue?vue&type=script&lang=ts"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__